import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
    const colorValue = semanticVariables?.[`semantic_icon_${color}`] || color;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 28 15"
            fill="none"
        >
            <path
                d="M13.9994 0.5C6.44693 0.5 0.25 6.69693 0.25 14.2494H2.18654C2.18654 7.76203 7.51203 2.43654 13.9994 2.43654C20.4869 2.43654 25.8123 7.76203 25.8123 14.2494H27.7489C27.8457 6.69693 21.6488 0.5 13.9994 0.5Z"
                fill={colorValue}
            />
            <path
                d="M15.1612 13.3783L17.8724 7.375L11.8691 10.0862C11.0945 10.4735 10.6104 11.3449 10.6104 12.2164C10.6104 13.5719 11.6754 14.637 13.031 14.637C13.9993 14.637 14.7739 14.1529 15.1612 13.3783Z"
                fill={colorValue}
            />
        </svg>
    );
};
